export const SITE_NAME = "Arıcıoğlu Nakliyat";
export const SITE_URL = "https://ankaradikmennakliyat.com";
export const DEFAULT_OG_IMAGE = "/1.jpeg";

export const DEFAULT_SEO = {
  title: "Dikmen Evden Eve Nakliyat | 0312 378 20 10 | Asansörlü Taşıma",
  description:
    "Ankara Dikmen çıkışlı evden eve nakliyat, asansörlü taşıma ve şehirler arası sevkiyat. Sigortalı, K1-K3 belgeli Arıcıoğlu ekibiyle hemen teklif alın.",
  keywords:
    "arıcıoğlu nakliyat, ankara nakliyat, dikmen evden eve nakliyat, asansörlü nakliyat ankara, şehirler arası nakliyat",
  image: DEFAULT_OG_IMAGE,
};

/** Her rota için özgün title, description ve keywords */
export const PAGE_SEO = {
  "/": {
    title: "Dikmen Evden Eve Nakliyat | 0312 378 20 10 | Asansörlü Taşıma",
    description:
      "Ankara Dikmen çıkışlı evden eve nakliyat, asansörlü taşıma ve şehirler arası sevkiyat. Sigortalı, K1-K3 belgeli Arıcıoğlu ekibiyle hemen teklif alın. Tel: 0312 378 20 10.",
    keywords:
      "arıcıoğlu nakliyat, ankara evden eve nakliyat, dikmen nakliyat, asansörlü taşıma ankara, k1 k3 nakliyat",
    image: "/1.jpeg",
  },
  "/hakkimizda": {
    title: "Hakkımızda | Arıcıoğlu Nakliyat Ankara",
    description:
      "35 yılı aşkın deneyimle Ankara ve Dikmen'de kurumsal nakliyat. K1-K3 yetki belgeli filomuz, kendi personelimiz ve sigortalı taşıma süreci.",
    keywords:
      "arıcıoğlu nakliyat hakkında, ankara nakliyat firması, k1 k3 yetki belgesi, kurumsal nakliyat ankara",
    image: "/3.jpeg",
  },
  "/ne-yapiyoruz": {
    title: "Ne Yapıyoruz | Ev, Asansör ve Ofis Nakliyatı",
    description:
      "Evden eve nakliyat, dış cephe asansörlü taşıma, ofis taşımacılığı ve eşya depolama. Dikmen ve Ankara genelinde anahtar teslim çözümler.",
    keywords:
      "nakliyat hizmetleri ankara, evden eve taşıma, asansörlü nakliyat, ofis taşımacılığı dikmen, eşya depolama",
    image: "/10.jpeg",
  },
  "/neden-biz": {
    title: "Neden Arıcıoğlu Nakliyat? | Dikmen'deki Fark",
    description:
      "Dikmen'in dar sokaklarına hakim ekip, kendi araç filomuz, Alman menşeli asansör ve tam kapsamlı sigorta. Ankara'da neden bizi seçiyorlar?",
    keywords:
      "neden arıcıoğlu nakliyat, güvenilir nakliyat ankara, sigortalı ev taşıma, dikmen nakliyat firması",
    image: "/9.jpeg",
  },
  "/evden-eve-nakliyat": {
    title: "Evden Eve Nakliyat Ankara | Paketleme ve Montaj",
    description:
      "Ankara içi evden eve nakliyat: demontaj, profesyonel paketleme, sigortalı yükleme ve yeni adreste montaj. Stresiz taşınma için Arıcıoğlu'nu arayın.",
    keywords:
      "evden eve nakliyat ankara, ev taşıma ankara, paketlemeli nakliyat, mobilya montaj nakliyat",
    image: "/8.jpeg",
  },
  "/asansorlu-nakliyat": {
    title: "Asansörlü Nakliyat Ankara | Dış Cephe Asansör",
    description:
      "Yüksek katlı ve dar merdivenli binalarda dış cephe asansörüyle taşıma. Eşyalar balkon veya pencereden iner; merdiven ve asansör hasarı olmaz.",
    keywords:
      "asansörlü nakliyat ankara, dış cephe asansör taşıma, yüksek kat nakliyat, balkon asansörü nakliye",
    image: "/15.jpeg",
  },
  "/dikmen-evden-eve-nakliyat": {
    title: "Dikmen Evden Eve Nakliyat | İlker, Birlik, Sokullu",
    description:
      "Dikmen, İlker, Birlik ve Sokullu'da ev taşıma. Site kurallarına uygun, sigortalı evden eve nakliyat. Aynı gün keşif ve net fiyat.",
    keywords:
      "dikmen evden eve nakliyat, ilker mahallesi nakliyat, birlik mahallesi taşıma, sokullu nakliyat",
    image: "/2.jpeg",
  },
  "/dikmen-asansorlu-nakliyat": {
    title: "Dikmen Asansörlü Nakliyat | Yüksek Kat Taşıma",
    description:
      "Dikmen yokuşları ve dar sokaklarda dış cephe asansör kurulumu. 25. kata kadar güvenli eşya indirme-çıkarma. Ücretsiz keşif için arayın.",
    keywords:
      "dikmen asansörlü nakliyat, dikmen dış cephe asansör, yüksek kat taşıma dikmen, dar sokak nakliyat",
    image: "/17.jpeg",
  },
  "/dikmen-sehirler-arasi-nakliyat": {
    title: "Dikmen Şehirler Arası Nakliyat | 81 İl Teslim",
    description:
      "Dikmen'den 81 ile sigortalı şehirler arası ev nakliyatı. Çelik kasa araç, kapıdan kapıya teslim ve sözleşmeli sevkiyat.",
    keywords:
      "dikmen şehirler arası nakliyat, ankara çıkışlı ev nakliyatı, 81 il nakliye, kapıdan kapıya taşıma",
    image: "/7.jpeg",
  },
  "/dikmen-ofis-tasimaciligi": {
    title: "Dikmen Ofis Taşımacılığı | İşyeri Taşınma",
    description:
      "Dikmen plazaları ve iş merkezlerinde ofis taşıma. Evrak, elektronik ve mobilya etiketlenir; mesai kaybını azaltan planlı operasyon.",
    keywords:
      "dikmen ofis taşımacılığı, işyeri nakliyat ankara, plaza taşıma, ofis mobilyası nakliye",
    image: "/6.jpeg",
  },
  "/dikmen-esya-depolama": {
    title: "Dikmen Eşya Depolama | Güvenli Depo",
    description:
      "Dikmen ve Ankara'da kısa veya uzun dönem eşya depolama. Kameralı, kuru ve sigortalı depo; ev veya ofis taşınırken geçici muhafaza.",
    keywords:
      "dikmen eşya depolama, ankara eşya deposu, güvenli mobilya depolama, geçici eşya muhafaza",
    image: "/14.jpeg",
  },
  "/iletisim": {
    title: "İletişim | Arıcıoğlu Nakliyat Ankara",
    description:
      "Keçiören Etlik ofisimiz, telefon ve WhatsApp ile 7/24 ulaşın. Ankara ve Dikmen nakliyat keşfi, fiyat ve randevu için hemen arayın: 0312 378 20 10.",
    keywords:
      "arıcıoğlu nakliyat iletişim, dikmen nakliyat telefon, ankara nakliyat adres, keçiören etlik nakliyat",
    image: "/3.jpeg",
  },
  "/teklif-al": {
    title: "Nakliyat Teklifi Al | Ankara Dikmen Fiyat",
    description:
      "Ev büyüklüğü, kat ve güzergaha göre ön fiyat alın. Dikmen ve Ankara nakliyat teklif formunu doldurun; ekibimiz sizi en kısa sürede arasın.",
    keywords:
      "nakliyat teklifi ankara, dikmen nakliyat fiyat, ev taşıma ücreti, online nakliyat teklifi",
    image: "/4.jpeg",
  },
};
